<template>
    <div class="tag-list-wrapper">
        <h3 class="tag-list-title">{{ title }}</h3>
        <div class="tag-list">
            <div
                class="tag-item"
                :class="{ 'tag-item--highlighted': tag.highlighted }"
                v-for="tag in props.tags"
                :key="tag.id"
            >
                {{ tag.name }}
            </div>
        </div>
    </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  title: {
    type: String,
    default: 'Criteria'
  },
  tags: {
    type: Array,
    // 格式：[{ id: string, name: string, highlighted: boolean }]
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  return {
    props
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.tag-list-wrapper {
    margin-bottom: 0.32rem;
}
.tag-list-title {
    margin-bottom: 0.1rem;
    font-size: 0.3rem;
    font-weight: 600;
    color: #000;
}

.tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.16rem 0.1rem;
}

.tag-item {
    display: inline-flex;
    align-items: center;

    padding: 0 0.15rem;
    height: 0.38rem;
    border-radius: 0.04rem;

    font-size: 0.22rem;
    line-height: 0.38rem;
    color: #262626;
    // 默认样式：灰色背景
    background: #ededed;

    // max-width: 5.8rem 超出显示省略号
    max-width: 5.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    // 高亮样式：橙色渐变背景
    &--highlighted {
        border: none;
        background: #f9c280;
        color: #4d250a;
    }
}
</style>
